import React, { useEffect, useContext, useState, useRef } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import "./SigninAndSignup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faL } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";
import OtpInput from "react-otp-input";
import { AuthContext } from "../../context/AuthContext";
import { Helmet } from "react-helmet-async";
import NavbarLogo from "../../Assets/Logo";

function ForgotPassword() {
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showOtpPage, setShowOtpPage] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [formdata, setformData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [otp, setOtp] = useState("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const InputEvent = (event) => {
    // console.log(formdata)
    const { name, value } = event.target;
    setformData((preval) => ({
      ...preval,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const btn = document.getElementById("verify-otp-btn");
    btn.classList.add("btn-click");
    setTimeout(() => {
      btn.classList.remove("btn-click");
    }, 200);

    const formData = new FormData();
    formData.append("Email", formdata.email);
    // Define the fetch promise
    const myPromise = fetch(
      `${process.env.REACT_APP_BACKEND_URL}/generate_otp`,
      {
        method: "POST",
        body: formData,
      }
    );

    // Use toast.promise for real-time feedback
    toast
      .promise(
        myPromise.then(async (res) => {
          const response = await res.json();
          console.log(response);
          if (!res.ok) {
            throw new Error(response.error || "Failed to generate OTP");
          }
          return response; // Return the successful response
        }),
        {
          loading: "Sending OTP To Verify...",
          success: "Otp sent Succesfully!",
          error: (err) => err.message || "Failed to send OTP.",
        }
      )
      .then((data) => {
        // On successful OTP generation
        setShowOtpPage(true); // Show the OTP page
      })
      .catch((data) => {
        // Handle failure with button animation
        console.log(data);
        btnFailedAnimation("verify-otp-btn");
      });
  };

  const btnFailedAnimation = (id) => {
    const failed = document.getElementById(id);
    setTimeout(() => {
      failed?.classList.add("shake-button");
    }, 500);
    setTimeout(() => {
      failed?.classList.remove("shake-button");
    }, 1000);
  };

  const handleVerifyOtp = async () => {
    const btn = document.getElementById("verify-otp-btn");
    btn.classList.add("btn-click");
    setTimeout(() => {
      btn.classList.remove("btn-click");
    }, 300);

    // Validate if OTP is provided
    if (!otp) {
      toast.error("Enter OTP to proceed");
      btnFailedAnimation("verify-otp-btn");
      return;
    }
    const formData = new FormData();
    formData.append("Email", formdata.email);
    formData.append("otp", otp);
    // Define the fetch promise
    const myPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/verify_otp`, {
      method: "POST",
      body: formData,
    });

    // Use toast.promise for user feedback
    toast
      .promise(
        myPromise.then(async (res) => {
          const data = await res.json();
          console.log(data);
          if (!res.ok) {
            throw new Error(data.error || "Failed to verify OTP");
          }
          return data; // Return the data if the response is OK
        }),
        {
          loading: "Verifying OTP...",
          success: "OTP verified successfully!",
          error: (err) => err.message || "Failed to verify OTP.",
        }
      )
      .then((data) => {
        // Handle success
        setAccessToken(data.access_token);
        setIsOtpVerified(true); // Mark OTP as verified
      })
      .catch(() => {
        // Handle error with button animation
        btnFailedAnimation("verify-otp-btn");
      })
      .finally(() => {
        setOtp(""); // Reset OTP field
      });
  };

  const handleResendOTP = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("Email", formdata.email);
    // Define the fetch promise
    const myPromise = fetch(
      `${process.env.REACT_APP_BACKEND_URL}/generate_otp`,
      {
        method: "POST",
        body: formData,
      }
    );

    // Use toast.promise for feedback
    toast
      .promise(
        myPromise.then(async (res) => {
          const response = await res.json();
          console.log(response);
          if (!res.ok) {
            throw new Error(response.error || "Failed to resend OTP");
          }
          return response; // Return successful response
        }),
        {
          loading: "Resending OTP...",
          success: "OTP resent successfully!",
          error: (err) => err.message || "Failed to resend OTP.",
        }
      )
      .then(() => {
        // On success, navigate to OTP page or show it
        setShowOtpPage(true);
      })
      .catch(() => {
        // Handle failure with button animation
        btnFailedAnimation("verify-otp-btn");
      })
      .finally(() => {
        setOtp(""); // Clear OTP field
      });
  };

  const handleResetPassword = async (event) => {
    event.preventDefault();

    const btn = document.getElementById("reset-btn");
    btn.classList.add("btn-click");
    setTimeout(() => {
      btn.classList.remove("btn-click");
    }, 300);

    const formData = new FormData();
    formData.append("Email", formdata.email);
    formData.append("password", formdata.password);
    formData.append("confirmPassword", formdata.confirmPassword);
    // Define the fetch promise
    const myPromise = fetch(
      `${process.env.REACT_APP_BACKEND_URL}/update_password`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      }
    );

    // Use toast.promise for user feedback
    toast
      .promise(
        myPromise.then(async (res) => {
          const data = await res.json();
          console.log(data);
          if (!res.ok) {
            throw new Error(data.error || "Failed to reset password");
          }
          return data; // Return successful response
        }),
        {
          loading: "Resetting password...",
          success: "Password reset successfully!",
          error: (err) => err.message || "Failed to reset password.",
        }
      )
      .then(() => {
        // On success
        setIsOtpVerified(false); // Clear OTP verification
        setShowOtpPage(false); // Hide OTP page
        navigate("/login"); // Redirect to login page
      })
      .catch(() => {
        // Handle failure with button animation
        btnFailedAnimation("reset-btn");
      });
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const pastedText = event.clipboardData.getData("text/plain");
    const input = event.target;
    const inputType = input.type; // Store the original input type
    input.type = "text"; // Temporarily change input type to "text"
    console.log(name);
    var newValue = value.substring(0, input.selectionStart) + pastedText;
    if (name !== "email") {
      newValue = newValue + value.substring(input.selectionEnd);
    }
    setformData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    // Change input type back to the original type
    input.type = inputType;

    // // Trigger the onChange event to update the state
    const changeEvent = new Event("input", { bubbles: true });
    input.dispatchEvent(changeEvent);
  };

  return (
    <>
      {!isAuthenticated && (
        <>
          <Helmet>
            <title>
              Reset your IzzyAi password - IzzyAI.com
            </title>
            <meta name="description"
              content="If you cannot remember your password, please fill in one of the fields below with your account information. We will send a link to reset your password to the email address on file."
            />
          </Helmet>
          <div className="outer-box pt-[80px] dark:bg-[#101920]  flex justify-center items-center">
            <div className="inner-box mx-auto my-auto">
              {showOtpPage ? (
                isOtpVerified ? (
                  <>
                    <header>
                      <div className="flex items-center justify-center mb-6">
                        <NavbarLogo />
                      </div>
                    </header>
                    <h2 className="text-center text-xl font-bold mb-4 dark:text-white">Password Reset</h2>
                    <p className="text-center text-gray-600 mb-6 dark:text-gray-200">Please enter password to update old one.</p>
                    <main className="signup-body mt-16">
                      <form onSubmit={handleResetPassword} className="form">
                        <div className="mb-1">
                          <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300"htmlFor="password">Password <span className="text-red-500">*</span></label>
                          <div className="relative">
                            <input
                              type={`${showPassword1 ? "text" : "password"}`}
                              className="dark:text-white flex h-9 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full pr-10"
                              id="password"
                              name="password"
                              value={formdata.password}
                              onChange={InputEvent}
                              title=" Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one special symbol (!@#$%^&*), and one digit."
                              placeholder="Enter your password here."
                              required
                              onPaste={handlePaste}
                            />
                            <button type="button" className="absolute inset-y-0 right-0 px-3 flex items-center justify-end md:w-12 w-10" style={{ backgroundColor: "transparent" }}>
                              {
                                showPassword1 ? <svg onClick={() => setShowPassword1(!showPassword1)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                  : <svg onClick={() => setShowPassword1(!showPassword1)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye-off h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
                              }
                            </button>
                          </div>
                        </div>
                        <div className="mb-1">
                          <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="confirmPassword">Password <span className="text-red-500">*</span></label>
                          <div className="relative">
                            <input
                              type={`${showPassword2 ? "text" : "password"}`}
                              className="dark:text-white flex h-9 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full pr-10"
                              id="confirmPassword"
                              name="confirmPassword"
                              placeholder="Re-enter your password"
                              required
                              onChange={InputEvent}
                              onPaste={handlePaste}
                              value={formdata.confirmPassword}
                            />
                            <button type="button" className="absolute inset-y-0 right-0 px-3 flex items-center justify-end md:w-12 w-10" style={{ backgroundColor: "transparent" }}>
                              {
                                showPassword2 ? <svg onClick={() => setShowPassword2(!showPassword2)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                  : <svg onClick={() => setShowPassword2(!showPassword2)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" className="lucide lucide-eye-off h-5 w-5 text-gray-500 hover:text-gray-700 dark:text-gray-200 dark:hover:text-gray-300"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
                              }
                            </button>
                          </div>

                        </div>
                        {formdata.password !== formdata.confirmPassword && (
                          <span className=" text-red-500 mt-5">
                            *Passwords do not match
                          </span>
                        )}
                        <div className="flex justify-center">
                          <input
                            type="submit"
                            id="reset-btn"
                            value="Reset Password"
                            className="create-account button  focus:outline-none inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow h-9 px-4 w-full mt-6 rounded-full  bg-black text-white hover:bg-gray-800"
                          />
                        </div>
                      </form>
                    </main>
                  </>
                ) : (
                  <>
                    <div className="container">
                      <div className="row justify-content-md-center">
                        <div className="col-md-4 text-center">
                          <div className="row">
                            <div className="col-sm-12 mt-5 bgWhite otp-section">
                              <div className="flex items-center justify-center mb-6">
                                <NavbarLogo />
                              </div>
                              <h2 className="text-center text-xl font-bold mb-4 dark:text-white">Verify OTP</h2>
                              <p className="text-center text-gray-600 mb-6 dark:text-gray-200">We've sent an OTP to {formdata.email}. Please enter it below.</p>
                              <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                containerStyle={{ justifyContent: "center" }}
                                renderInput={(props) => (
                                  <input
                                    {...props}
                                    style={{
                                      display: "inline-block",
                                      width: "50px",
                                      height: "50px",
                                      textAlign: "center",
                                      border: "1px solid black",
                                      borderRadius: "4px",
                                      marginRight: "5px", // Optional: To add some space between the inputs
                                    }}
                                  />
                                )}
                                placeholder="000000"
                                onPaste={handlePaste}
                              />
                              <hr className="  mt-5 mb-2" />
                              <div className="flex justify-center">
                                <input
                                  type="submit"
                                  id="verify-otp-btn"
                                  value="Verify"
                                  onClick={handleVerifyOtp}
                                  className="create-account button  focus:outline-none inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow h-9 px-4 w-full mt-6 rounded-full  bg-black text-white hover:bg-gray-800"
                                />
                              </div>
                              <footer className="signup-footer footer-in-singup">
                                <p className="text-md text-gray-500 dark:text-gray-300">Already have an account?
                                  <NavLink to="/login" className="marginDown hover:underline ml-2 text-blue-500">
                                    Sign In
                                  </NavLink>
                                </p>
                                <p className="text-md text-gray-500 dark:text-gray-300">Didn't receive OTP?
                                  <NavLink to="/login" className="marginDown hover:underline ml-2 text-blue-500"
                                    onClick={handleResendOTP}>
                                    Resend OTP
                                  </NavLink>
                                </p>
                              </footer>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )
              ) : (
                <>
                  <div className="row">
                    <div className="flex items-center justify-center mb-6">
                      <NavbarLogo />
                    </div>
                    <h2 className="text-center text-xl font-bold mb-4 dark:text-white">Login</h2>
                    <p className="text-center text-gray-600 mb-4 dark:text-gray-200">Login to get started with IzzyAI</p>

                    <div className="form-group">
                      <form className="form" onSubmit={handleSubmit}>
                        <div>
                          <label className="block text-sm  text-gray-700 mb-1 dark:text-gray-300" htmlFor="forgotPasswordEmail">
                            Enter your email to generate OTP</label>
                          <input
                            type="email"
                            className="dark:bg-[#101920] flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm  "
                            id="forgotPasswordEmail"
                            name="email"
                            value={formdata.email}
                            onChange={InputEvent}
                            title="Enter a valid email address"
                            required
                            placeholder="Enter your email"
                          />
                        </div>
                        <div className="flex justify-center">
                          <input
                            type="submit"
                            id="verify-otp-btn"
                            value="Reset Password"
                            className="create-account button  inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors  disabled:pointer-events-none disabled:opacity-50 shadow h-9 px-4 w-full mt-6 rounded-full  bg-black text-white hover:bg-gray-800"
                          />
                        </div>

                      </form>
                    </div>
                    <div className="footer">
                      <p className="text-md text-gray-500 dark:text-gray-300">New here?
                        <NavLink to="/signup" className="marginDown hover:underline ml-2 text-blue-500">
                          Sign Up.
                        </NavLink>
                      </p>
                      <p className="text-md text-gray-500 dark:text-gray-300">Already have an account?
                        <NavLink to="/login" className="marginDown hover:underline ml-2 text-blue-500">
                          Sign In.
                        </NavLink>
                      </p>

                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ForgotPassword;
